import { groupByKey } from "../../../../helper/utils";
import reportThunkActions from "./reportThunk";

function createExtraReducers() {
  return {
    ...fetchReportDetails(),
    ...fetchAchievementDetails(),
    ...fetchFocussedSku(),
    ...getTargetFilters(),
    ...fetchAchievementDetailsFilterWise(),
    ...getSubordinateFilter(),
    ...getSubordinates(),
    ...getSubordinatesForRole(),
    ...getAllManagersForRole(),
  };

  function fetchReportDetails() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.fetchReportDetails;
    return {
      [pending]: (state) => {
        state.fetchReportDetails.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.fetchReportDetails = {
          isLoading: false,
          error: null,
          data: JSON.parse(action?.payload)?.data || [],
        };
      },
      [rejected]: (state, action) => {
        state.fetchReportDetails = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
        };
      },
    };
  }
  function fetchAchievementDetails() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.fetchAchievementDetails;
    return {
      [pending]: (state) => {
        state.fetchAchievementDetails.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.fetchAchievementDetails = {
          isLoading: false,
          error: null,
          data: JSON.parse(action?.payload)?.data || [],
        };
      },
      [rejected]: (state, action) => {
        state.fetchAchievementDetails = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }

  function fetchFocussedSku() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.fetchFocussedSku;
    return {
      [pending]: (state) => {
        state.fetchFocussedSku.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.fetchFocussedSku = {
          isLoading: false,
          error: null,
          data: JSON.parse(action?.payload) || [],
        };
      },
      [rejected]: (state, action) => {
        state.fetchFocussedSku = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
        };
      },
    };
  }
  function getTargetFilters() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.getTargetFilters;
    return {
      [pending]: (state) => {
        state.getTargetFilters.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.getTargetFilters = {
          isLoading: false,
          error: null,
          data: groupByKey(JSON.parse(action?.payload)) || [],
        };
      },
      [rejected]: (state, action) => {
        state.getTargetFilters = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function fetchAchievementDetailsFilterWise() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.fetchAchievementDetailsFilterWise;
    return {
      [pending]: (state) => {
        state.fetchAchievementDetailsFilterWise.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        state.fetchAchievementDetailsFilterWise = {
          isLoading: false,
          error: null,
          data: JSON.parse(action?.payload) || [],
        };
      },
      [rejected]: (state, action) => {
        state.fetchAchievementDetailsFilterWise = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }

  function getSubordinateFilter() {
    const { pending, fulfilled, rejected } =
      reportThunkActions.getSubordinateFilter;

    return {
      [pending]: (state) => {
        state.subordinates.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        const subOrdinateData = JSON.parse(action?.payload?.data)?.data;

        state.subordinates = {
          isLoading: false,
          error: null,
          data: subOrdinateData || [],
        };
      },
      [rejected]: (state, action) => {
        state.subordinates = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }

  function getSubordinates() {
    const { pending, fulfilled, rejected } = reportThunkActions.getSubordinates;

    return {
      [pending]: (state) => {
        state.subordinates.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        const subOrdinateData = JSON.parse(action?.payload?.data)?.data;

        state.subordinates = {
          isLoading: false,
          error: null,
          data: subOrdinateData || [],
        };
      },
      [rejected]: (state, action) => {
        state.subordinates = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getSubordinatesForRole() {
    const { pending, fulfilled, rejected } = reportThunkActions.getSubordinatesForRole;

    return {
      [pending]: (state) => {
        state.subordinatesForRole.isLoading = true;
      },
      [fulfilled]: (state, action) => {
        const subOrdinateData = JSON.parse(action?.payload?.data)?.data;

        state.subordinatesForRole = {
          isLoading: false,
          error: null,
          data: subOrdinateData || [],
        };
      },
      [rejected]: (state, action) => {
        state.subordinatesForRole = {
          isLoading: false,
          error: action.payload.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  function getAllManagersForRole() {
    return {
      [reportThunkActions.getAllManagersForRole.pending]: (state) => {
        state.managersForRole.isLoading = true;
      },
      [reportThunkActions.getAllManagersForRole.fulfilled]: (state, action) => {
        const safe = Array.isArray(action.payload) ? action.payload : [];
        const parsed = safe.map((m) => ({
          label: m.name,
          id: m.employee_id,
        }));
        state.managersForRole = {
          isLoading: false,
          error: null,
          data: parsed,
        };
      },
      [reportThunkActions.getAllManagersForRole.rejected]: (state, action) => {
        state.managersForRole = {
          isLoading: false,
          error: action.payload?.error || "Something Went Wrong",
          data: [],
        };
      },
    };
  }
  
}

const reportExtraReducers = createExtraReducers();
export default reportExtraReducers;
